const colors = {
  primary100: '#F0F2F4',
  primary200: '#C4D2DC',
  primary300: '#B1C4D2',
  primary400: '#96B2C6',
  primary500: '#749BB8',
  primary600: '#4E80A5',
  primary700: '#426B89',
  primary800: '#395A71',
  primary900: '#30495A',
  primary1000: '#2A3E4B',

  secondary100: '#F4FAFB',
  secondary200: '#EFF8F9',
  secondary300: '#E1F0F3',
  secondary400: '#CCE4E7',
  secondary500: '#B2D0D5',
  secondary600: '#96B5BA',
  secondary700: '#7C9295',
  secondary800: '#59777B',
  secondary900: '#345F65',
  secondary1000: '#183E44',

  gray100: '#fdfdfd',
  gray200: '#EBEBEB',
  gray300: '#E1E1E1',
  gray400: '#D3D3D3',
  gray500: '#A2A2A2',
  gray600: '#8B8989',
  gray700: '#676767',
  gray800: '#5b5b5b',
  gray900: '#3c3c3c',
  gray1000: '#202020',

  success100: '#F0FDF4',
  success200: '#DCFCE7',
  success300: '#BBF7D0',
  success400: '#86EFAC',
  success500: '#4ADE80',
  success600: '#22C55E',
  success700: '#16A34A',
  success800: '#15803D',
  success900: '#166534',
  success1000: '#14532D',
  success1100: '#0C331C',

  warning100: '#FEFCE8',
  warning200: '#FEF9C3',
  warning300: '#FEF08A',
  warning400: '#FDE047',
  warning500: '#FACC15',
  warning600: '#EAB308',
  warning700: '#CA8A04',
  warning800: '#A16207',
  warning900: '#854D0E',
  warning1000: '#713F12',
  warning1100: '#4D2B0C',

  danger100: '#FEF2F2',
  danger200: '#FEE2E2',
  danger300: '#FCA5A5',
  danger400: '#F87171',
  danger500: '#EF4444',
  danger600: '#DC2626',
  danger700: '#B91C1C',
  danger800: '#991B1B',
  danger900: '#7F1D1D',
  danger1000: '#4D1111',
  danger1100: '#330C0C',
  backgroundBase: '#ffffff',
  backgroundSurface: '#fbfbfb',
  backgroundElevated: '#f8f8f8',
  backgroundMuted: '#ffffff',
  backgroundAccent: '#f4f4f4',
}

export const tokens = {
  colors,
  semanticColors: {
    actions: {
      primary: {
        default: colors.primary600,
        hover: colors.primary700,
        disabled: colors.gray200,
        textDisabled: colors.gray400,
        text: colors.gray100,
      },
      light: {
        default: colors.primary100,
        hover: colors.primary200,
        text: colors.primary1000,
        textDisabled: colors.primary400,
      },
      white: {
        default: colors.gray200,
        hover: colors.gray100,
        disabled: colors.gray600,
      },
      gray: {
        default: colors.gray100,
        hover: colors.gray200,
        text: colors.gray900,
        textDisabled: colors.gray500,
      },
    },
    general: {
      border: {
        default: colors.gray200,
        borderStrong: colors.gray300,
      },
      background: {
        base: colors.backgroundBase,
        surface: colors.backgroundSurface,
        elevated: colors.backgroundElevated,
        muted: colors.backgroundMuted,
        accent: colors.backgroundAccent,
      },
      icon: {
        default: colors.gray600,
      },
    },
    input: {
      border: {
        default: colors.gray300,
        hover: colors.primary300,
        focus: colors.primary600,
        error: colors.danger500,
        disabled: colors.gray300,
      },
      background: {
        defaul: colors.backgroundBase,
        filled: colors.backgroundSurface,
        disabled: colors.backgroundMuted,
      },
      text: {
        labelDefault: colors.gray900,
        labelDisabled: colors.gray500,
        placeholder: colors.gray300,
        default: colors.gray700,
        disabled: colors.gray700,
        icon: colors.gray700,
      },
    },
  },
  space: {
    1: '0.25rem', // 4px
    2: '0.5rem', // 8px
    3: '0.75rem', // 12px
    4: '1rem', // 16px
    5: '1.5rem', // 24px
    6: '2rem', // 32px
    7: '2.5rem', // 40px
    8: '3rem', // 48px
    9: '4rem', // 64px
  },
  fontSizes: {
    1: '0.75rem', // 12px
    2: '0.875rem', // 14px
    3: '1rem', // 16px
    4: '1.125rem', // 18px
    5: '1.25rem', // 20px
    6: '1.5rem', // 24px
    7: '2.5rem', // 40px
    8: '3rem', // 48px
  },
  fonts: {
    standard: 'Roboto, sans-serif',
  },
  fontWeights: {
    light: '300',
    normal: '400',
    medium: '600',
    bold: '700',
  },
  lineHeights: {
    small: '1.2',
    medium: '1.5',
    large: '1.8',
  },
  letterSpacings: {},
  sizes: {},
  borderWidths: {
    thin: '0.0625rem', // 1px
    medium: '0.125rem', // 2px
    thick: '0.1875rem', // 3px
  },
  radii: {
    xsmall: '0.25rem', // 4px
    small: '0.5rem', // 8px
    medium: '0.75rem', // 12px
    large: '1rem', // 16px
  },
  shadows: {},
  zIndexes: {
    1: '100',
    2: '200',
    3: '300',
    4: '400',
    5: '500',
  },
  transitions: {},
}
